import { RootState } from "../../../store";
import {
  cloudChiprApi,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { getAccountsOrderingSettingsKey } from "../../../../components/pages/account/utils/hooks/useAccountsDnD";
import { AccountTabs } from "../../../../components/pages/accounts-group/utils/types/types";
import { accountsSortBySelector } from "../slice-data/accountsSortBySelector";

const selector =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select;
export const accountsOrderingLoadingSelector = (
  state: RootState,
  provider: ProviderType,
  tabValue: AccountTabs,
  orgId?: string,
) => {
  const sortBy = accountsSortBySelector(state);

  const key = getAccountsOrderingSettingsKey(provider, tabValue, orgId);

  const data = selector({ key })(state);

  return data?.error || sortBy ? false : data.isLoading;
};
